import { Field } from 'formik';
import { SttNumberInput } from '@stt-componentes/core';
import { NUMERO_EXAME } from '../fieldNames';

const NumeroExame = ({ strings }) => {
    return (
          <Field name={NUMERO_EXAME}>
            {({
                field
            }) => (
                <SttNumberInput
                    label={strings.numeroLaudo}
                    {...field}
                />
            )}
        </Field>
    )
};

export default NumeroExame;